import { z } from 'zod';
/** Data sources a response was computed from. */
export const SourceSchema = z.enum(['ghost-postgres', 'enigma-silver', 'dashboard']);
export const IsoDateSchema = z.iso.date(); // YYYY-MM-DD
export const YearMonthSchema = z.string().regex(/^\d{4}-\d{2}$/, 'expected YYYY-MM');
export const ArtistIdSchema = z.string().min(1).max(64);
export const TrackIdSchema = z.string().min(1).max(64);
export const MetaSchema = z.object({
    artistId: ArtistIdSchema.optional(),
    anchor: IsoDateSchema.optional(),
    /** Opaque; equal values mean the same underlying data. Also used as the ETag. */
    version: z.string(),
    computedAt: z.iso.datetime(),
    sources: z.array(SourceSchema),
    /** Caveats worth rendering (premium-only markets, collab attribution, partial month excluded). */
    notes: z.array(z.string()),
});
export function envelope(data) {
    return z.object({ data, meta: MetaSchema });
}
export const ProblemCodeSchema = z.enum([
    'validation_error',
    'unauthenticated',
    'forbidden',
    'not_found',
    'territory_not_ingested',
    'no_data',
    'conflict',
    'upstream_unavailable',
    'internal',
]);
/** RFC 9457 problem details. */
export const ProblemSchema = z.object({
    type: z.string(),
    title: z.string(),
    status: z.number().int(),
    detail: z.string().optional(),
    instance: z.string().optional(),
    code: ProblemCodeSchema,
    errors: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
});
//# sourceMappingURL=common.js.map